import React from "react";
import Moment from 'moment';

import { Card, CardBody, Table } from "reactstrap";
const GiftCardTable = ({giftVoucherList}) => {
  //console.log("empGiftVouchers",giftVoucherList)
  return (
    <Card className="flex-fill">
      <CardBody>
        {/* <CardTitle>
            <h3>Gift Card</h3>
          </CardTitle> */}
        <Table style={{ border: "" }}>
          <thead>
            <tr>
              <th width="10%">#</th>
              <th width="60%">Gift Card</th>
              <th>Expire Date</th>
            </tr>
          </thead>
          <tbody>
          {giftVoucherList.length > 0 ? (giftVoucherList.map((rowData, i) => (
            <tr key={i}>
              <td>{i + 1}</td>
              <td>{rowData.giftOption}</td>
              <td>{Moment(rowData.expiryDate).format("DD-MM-YYYY")}</td>
            </tr>
          ))) : (
            <tr>
              <td colSpan={4} style={{textAlign : "center"}}>No Gift Voucher Assigned</td>
            </tr>
          )
          
          }
          </tbody>
        </Table>
      </CardBody>
    </Card>
  );
};

export default GiftCardTable;
